<template>
  <div class="detect_detail">
    <div class="property_index_search">
      <div class="property_index_search_input">
        <div style="width: 850px;">
          <el-input
            placeholder="请输入或选择查询内容"
            prefix-icon="el-icon-search"
            v-model="searchData"
            @input="inputValueChange"
            @focus="getValueMethods"
            style="border-radius:30px;">
            <!-- <el-button
              size="mini"
              style="line-height: 26px;"
              slot="suffix"
              type="text"
              @click="dialogManager = true">
            选择
            </el-button> -->
                
            <el-select v-model="selectSearchData" slot="append" placeholder="" style="border-left: 0px; width: 230px;" @change="resetForm('SForm')">
              <el-option label="根据资产名称查询" value="1"></el-option>
              <el-option label="根据状态查询" value="2"></el-option>
            </el-select>
          </el-input>
        </div>
        <div>
          <el-button type="text"  @click="select(1)" style="font-size: 16px; color: #121212; margin-left: 24px;">查询</el-button>
          <el-button type="text"  @click="resetForm('SForm')" style="font-size: 16px; color: #121212; margin-left: 24px;">重置</el-button>
        </div>
      </div>
    </div>

    <el-dialog title="根据状态查询" :visible.sync="dialogStates" width="35%">
      <span>根据状态查询:</span>
      <el-select v-model.trim="selectStates" placeholder="根据单位查询" @change="statesChange">
        <el-option
        v-for="i in statesList"
        :label="i.label"
        :key="i.value"
        :value="i">
        </el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogStates = false">取 消</el-button>
        <el-button type="primary" @click="dialogStates = false;">确 定</el-button>
      </div>
    </el-dialog>
    <!-- <el-container class="SelectBlock">


      <el-col class="FirstBlock" :sapn="3" >
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            选择查询的需要<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">根据任务名称查询</el-dropdown-item>
            <el-dropdown-item command="b">根据状态查询</el-dropdown-item>

          </el-dropdown-menu>
        </el-dropdown>


          <el-input v-if="selectCheck == 'a'" v-model.trim="SForm.taskName" placeholder="根据资产名称查询"></el-input>
          <el-select v-if="selectCheck == 'b'" v-model.trim="SForm.state" placeholder="是否为资产状态">
            <el-option label="进行中" value='1'></el-option>
            <el-option label="待审核" value='2'></el-option>
            <el-option label="已完成" value='3'></el-option>
            <el-option label="已驳回" value='4'></el-option>
            <el-option label="已终止" value='5'></el-option>
          </el-select>

        <el-button type="primary" @click="select(1)">查询</el-button>
        <el-button type="primary" @click="resetForm('SForm')">重置</el-button>
      </el-col>

    </el-container> -->


     <el-table
        :data="tableData"
        style="width: 100%;margin-top: 2%;">
        <el-table-column
          prop="taskName"
          label="清查任务名称">
        </el-table-column>
        <el-table-column
          prop="checker"
          label="清查人"
          width="180">
        </el-table-column>
        <!-- <el-table-column
          prop="taskCount"
          label="清查数量">
        </el-table-column> -->

        <el-table-column
          prop="createDate"
          label="预计完成时间">
        </el-table-column>


        <el-table-column
          label="资产状态"
          prop="state">
          <template slot-scope="scope">
            <!-- <el-tag
            :type="scope.row.state == 1?''
            :(scope.row.state==2?'success'
            :(scope.row.state==3?''
            :(scope.row.state==4?''
            :(scope.row.state==5?'danger':'warning'))))"
            effect="dark"> -->
              <div v-if="scope.row.state == 1" style="color: #0D67FC;">进行中</div>
              <div v-if="scope.row.state == 2">待审核</div>
              <div v-if="scope.row.state == 3" style="color: #0D67FC;">已完成</div>
              <div v-if="scope.row.state == 4" style="color: #CD1515;">已驳回</div>
              <div v-if="scope.row.state == 5" style="color: #31986F;">已终止</div>
            <!-- </el-tag> -->
          </template>
        </el-table-column>
        <el-table-column label="操作">
            <template slot-scope="scope">
              <!-- <el-select  v-model.trim="tableData[scope.$index].Num" placeholder="是否为资产状态">
                <el-option label="进行中" value='1'></el-option>
                <el-option label="待审核" value='2'></el-option>
                <el-option label="已完成" value='3'></el-option>
                <el-option label="已驳回" value='4'></el-option>
                <el-option label="已终止" value='5'></el-option>
              </el-select> -->
              <el-button type="small" @click="ShengHe(scope.row, 3)" style="color: #0D67FC; background-color: rgba(66,133,244,0.1);">完成</el-button>
              <el-button type="small" @click="ShengHe(scope.row, 4)" style="color: #CD1515; background-color: rgba(205,21,21,0.1);">驳回</el-button>
              <el-button type="small" @click="ShengHe(scope.row, 5)" style="color: #31986F; background-color: rgba(68,177,134,0.1);">终止</el-button>
            </template>
        </el-table-column>
      </el-table>
      <el-pagination  
        style="margin: 60px 60px 0 0; padding-bottom: 30px; display: flex; flex-direction: row-reverse;"      
        @current-change="handleCurrentChange"
        :current-page.sync="pageNum"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
  </div>
</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  export default {
     name: 'DetectAllDataDetail',
     data () {
       return {
       // 存入选中的搜索框的数据
        // selectCheck:'',
				searchData: '',
        selectSearchData: '',
        dialogStates: false,
        statesList: [
          {label: '进行中', value: 1},
          {label: '待审核', value: 2},
          {label: '已完成', value: 3},
          {label: '已驳回', value: 4},
          {label: '已终止', value: 5},
        ],
        // 搜索功能的条件
        SForm:{
          state: '',
          detectName: '',
          taskName: '',
        },
        pageNum: 1,
        pageSize: 10,
        total: 0,
		// 资产清查所有清查资产的数据字段
        tableData:[{
          belongDetectId:'',
          checker:'',
          checkerId:'',
          createDate:'',
          del:'',
          endDate:'',
          state:'',
          taskCount:'',
          taskId:'',
          taskName:'',
          unit:'',
          unitId:'',
          Num:''
        }],
      };
     },
    mounted:function() {
       this.select();
     },
    methods: {
      // 将input输入框的值赋予对应位置
      inputValueChange() {
        this.selectSearchData === '1' ? 
          this.SForm.taskName = this.searchData : ''
      },
      
      getValueMethods(){
        switch (this.selectSearchData) {
          case '2': 
            this.dialogStates = true
            break
        }
      },

      statesChange(e) {
        this.SForm.state = e.value
        this.searchData = e.label
      },

	    // 重置数据
      resetForm(formName) {
        Object.assign(this.$data.SForm, this.$options.data().SForm)
        this.pageNum = 1
        this.select()
      },


	    //根据条件查询
      select(val){
        var authorization = Cookies.get("Authorization");
        var paramsData = {
          state:this.SForm.state|| undefined,
          taskName:this.SForm.taskName|| undefined,
          currentPage: this.pageNum,
          pageSize: this.pageSize,
        }
        this.axios({
          method: 'GET',
          url: '/detect/taskSearch',
          params:paramsData,
          header:{
            'Authorization':authorization,
            'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
            }
        }).then((resp)=>{
          console.log(resp)
          this.tableData = resp.data.data;
          this.total = resp.data.count;
        })
      },
      
      handleCurrentChange(pageNum) {
        console.log(pageNum)
        this.pageNum = pageNum
        this.select()
      },

	  // 下拉菜单存放点击时选中的数据
      handleCommand(command) {
        this.selectCheck = command
      },

	  // 清查数据的审核功能
      ShengHe(val, state){
        var authorization = Cookies.get("Authorization");
        var params = {
          taskId:parseInt(val.taskId),
          state: state,
        }
         this.axios({
             method: 'POST',
             url: '/detect/applyTask',
             params:params,
             header:{
              'Authorization':authorization,
             	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
             	}
           }).then((res)=>{
            console.log(res.data.code)
              if(res.data.code == 200) {
                this.select();
                this.$message.success('提交成功')
              } else {
                this.$message.error(res.data.message)
              }
              
           })


      },



	  // 清查详情数据展现
      showData(){
        var authorization = Cookies.get("Authorization");
        var params = {
          currentPage: 1,
          pageSize: 10,
        }
        this.axios({
          method: 'GET',
          url: '/detect/taskSearch',
          params:params,
          header:{
          'Authorization':authorization,
          'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
          }
        }).then((resp)=>{
          this.tableData = resp.data.data
        })
      }
     }
   }
</script>

<style lang="less">
  .detect_detail {
    background: #fff;
    width: 1650px;

    .property_index_search {
      
      color: #7F8F9B !important;
      display: flex;
      // justify-content: space-between;
      // flex-direction: column;
      
      .property_index_search_input {
        // width: 850px;
        padding: 24px 60px;
        border-radius: 30px;
        display: flex;
        margin: 0 auto;
        flex-direction: column;

        .property_index_search_input_text {
          line-height: 45px; 
          margin-left: 24px;
          color: #121212;
          font-size: 16px;
        }
      }

      .property_index_search_button {
        margin: 24px 50px 0 0;
        display: flex;
        justify-self: start;
      }
      .el-input__inner {
        background: #F5F5F5 !important;
        border: 30px; 
        // border-radius: 30px 0 0 30px;
        color: #7F8F9B;
      } 
    } 
  }
</style>



// WEBPACK FOOTER //
// src/components/Detect/DetectAllDataDetail.vue